import { render, staticRenderFns } from "./AnulacionesView.vue?vue&type=template&id=84980196&scoped=true"
import script from "./AnulacionesView.vue?vue&type=script&lang=js"
export * from "./AnulacionesView.vue?vue&type=script&lang=js"
import style0 from "./AnulacionesView.vue?vue&type=style&index=0&id=84980196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84980196",
  null
  
)

export default component.exports